import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getsubdomainType, getvenue } from '../../../services/admin/defaultSetup/esSeriesSetupServices';
import {getSeriesType}  from '../../../services/admin/defaultSetup/esSeriesTypeServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';


const EsSeriesSetup = () => {
  const [dataList, setDataList] = useState([]);
  const [seriesType, setSeriesType] = useState([]);
  const [form, setForm] = useState({ id: '', series: '', sub_domain: '', venue: ''});

  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [subdomainType, setsubdomainType] = useState([]);
  const [venue, setvenue] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  
  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData();
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

useEffect(() => {
    const fetchsubdomainType = async () => {
      try {
        const data = await getsubdomainType(); // Fetch data from the service
        const sortedAscOrderData = data.sort((a, b) =>a.sub_domain.localeCompare(b.sub_domain));
        setsubdomainType(sortedAscOrderData); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchsubdomainType();
  }, []);

  useEffect(() => {
    const fetchSeriesType = async () => {
      try {
        const data = await getSeriesType({is_active:"active"}); // Fetch data from the service
        setSeriesType(data); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchSeriesType();
  }, []);

useEffect(() => {
    const fetchVenue = async () => {
      try {
        const data = await getvenue(); // Fetch data from the service
        setvenue(data); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchVenue();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    // Clear any previous errors for this field
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
 
    // Check if code or name fields are empty or just whitespace
    if (!form.series || !form.series.trim()) {newErrors.series = 'Series is required';}
    if (!form.sub_domain || !form.sub_domain.trim()) {newErrors.sub_domain = 'Subdomain is required';}
    if (!form.venue || !form.venue.trim()) {newErrors.venue = 'Venue is required';}
 
    // ✅ Duplicate check (series + sub_domain)
    const isDuplicate = dataList.some(item =>
      item.id !== form.id &&
      item.series?.trim().toLowerCase() === form.series.trim().toLowerCase() &&
      item.sub_domain?.trim().toLowerCase() === form.sub_domain.trim().toLowerCase()
    );

    if (isDuplicate) {
      newErrors.sub_domain = `This ${formatSeriesLabel(form.series)} with selected ${form.sub_domain} already exists`;
    }

    // Set the error state if there are validation errors
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;  // Return true if no errors
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      if (modalType === 'add') {
        await addData(form);
      } else if (modalType === 'edit') {
        await updateData(form);
      }
      fetchData();
      setShowModal(false);
    // ✅ Show success alert with auto-close
        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Series Setup ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
            timer: 2000, // 2 seconds
            showConfirmButton: false,
        });
        } catch (error) {
        console.error('Error during form submission:', error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Something went wrong while submitting the form!',
        });
        }
  };

  const handleDelete = async () => {
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
    }
  };

  const openModal = (type, data = { id: '', series: '', sub_domain: '', venue: '' }) => {
    setErrors({}); // ✅ Clear previous errors
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter(
      (data) =>
        data?.sub_domain?.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Series',
      selector: (row) => row.series,
      sortable: true,
      width: '20%',
      wrap: true
    },
    {
    name: 'Subdomain',
    selector: (row) => row.sub_domain,
    sortable: true,
    width: '15%',
    wrap: true
    },
    {
    name: 'Venue',
    selector: (row) => row.venue,
    sortable: true,
    width: '20%',
    wrap: true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
      width: '25%',
      wrap: true
    },
  ];
  const formatSeriesLabel = (value) => {
  if (!value) return "";

  const [year, month] = value.split("-");
  const date = new Date(year, month - 1);

  return date.toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
};



 const options = seriesType
  .sort((a, b) => a.series.localeCompare(b.series)) // ASC order
  .map((series_type) => ({
    value: series_type.series,
    label: formatSeriesLabel(series_type.series),
  }));


  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4 text-dark'>General Configuration / Default Setup / Series Setup</p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} backdrop="static" onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>    
                <div className="row">      
                  <Form.Group className="col-md-12 mb-3">
                  <Form.Label className="fs-5 text-dark">Series Type <small className='fs-5 text-danger'>*</small></Form.Label>
                  {/* <Form.Control type="month" name="series" value={form.series} onChange={handleChange} isInvalid={!!errors.series}/> */}
                  <Form.Control className="form-select mb-3" as="select" name="series" value={form.series} onChange={handleChange} isInvalid={!!errors.series}>
                    <option value="">Select</option>
                    {options.map((series) => (
                        <option key={series.value} value={series.value}>
                        {series.label}
                        </option>
                    ))}
                </Form.Control>
                  <Form.Control.Feedback type="invalid">  {errors.series} </Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className="fs-5 text-dark">Subdomain Type <small className='fs-5 text-danger'>*</small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="sub_domain" value={form.sub_domain} onChange={handleChange} isInvalid={!!errors.sub_domain}>
                    <option value="">Select</option>
                    {subdomainType.map((subdomain) => (
                        <option key={subdomain.sub_domain} value={subdomain.sub_domain}>
                        {subdomain.sub_domain}
                        </option>
                    ))}
                </Form.Control>
               <Form.Control.Feedback type="invalid">  {errors.sub_domain} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className="fs-5 text-dark">Venue <small className='fs-5 text-danger'>*</small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="venue" value={form.venue} onChange={handleChange} isInvalid={!!errors.venue}>
                    <option value="">Select</option>
                    {venue.map((venue) => (
                        <option key={venue.venue} value={venue.venue}>
                        {venue.venue}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.venue} </Form.Control.Feedback>
                </Form.Group>
                
                </div>
                
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default EsSeriesSetup;